<main>
  <div [style.opacity]="disabled ? 0.5 : 1" [style.border]="border ? 'solid 1px #000' : ''" class="input-wrapper" [style.background-color]="background"
    [style.height]="size === 'small' ? '38px' : '46px'" [style.border-radius]="borderRadios ? '8px' : '4px'"
    [style.border-color]="control.value ? '#008A2F' : error ? '#ff0000' :'#000'"
    [class.floating]="control.value || isOpenModal" (click)="openModal()">
    <label [style.background-color]="background" [style.color]="control.value ? '#008A2F' : error ? '#ff0000' :'#000'"
      class="label">{{ label }}</label>
    <span [style.padding-left]="'15px'" [style.font-size]="'13px'">{{valueOptionSelected.label}}</span>
    <div class="input">
      <span class="material-symbols-outlined">{{ icon }}</span>
    </div>

  </div>
  @if (isOpenModal) {
  @if(options.length > 0) {
  <div class="modal-fade" (click)="openModal()">
    <div class="modal">
      <div class="content">
        @for(option of options; track option) {
        <span class="value" (click)="optionSelect(option)">{{ option.label }}</span>
        }
      </div>
    </div>
  </div>
  } @else {
  <div class="modal-fade" (click)="openModal()">
    <div class="modal">
      <div class="content">
        <span class="value">Nenhuma informação encontrada !</span>
      </div>
    </div>
  </div>

  }

  }
  @if(error) {
  <h6>Campo Obrigatorio</h6>
  }
</main>
